import {
  MessageActionButton,
  MessageActionsButtons,
  MessageActionsContainer,
} from "../MessagePanel.style";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import React from "react";
import { IMessage } from "@home-health-notify/domain";

interface MessageActionButtonsProps {
  replyMessage: IMessage | undefined;
  cancelReplyMode: () => void;
  send: () => void;
  isPriority: boolean;
  setPriority: (isPriority: boolean) => void;
  isChatMessageEmpty: boolean;
}

export const MessageActionButtons = ({
  replyMessage,
  cancelReplyMode,
  setPriority,
  isPriority,
  send,
  isChatMessageEmpty,
}: MessageActionButtonsProps) => {
  return (
    <MessageActionsButtons>
      {!replyMessage && (
        <MessageActionButton
          data-testid="priority-button"
          type="button"
          aria-label="High Priority"
          onClick={() => setPriority(!isPriority)}
        >
          <WarningRoundedIcon
            color={isPriority ? "error" : "disabled"}
            fontSize="large"
          />
        </MessageActionButton>
      )}
      <MessageActionsContainer>
        {replyMessage && (
          <MessageActionButton
            data-testid="cancel-reply-button"
            aria-label="Cancel"
            onClick={cancelReplyMode}
          >
            <CloseIcon fontSize="large" color="primary" />
          </MessageActionButton>
        )}
        <MessageActionButton
          aria-label="Send"
          onClick={send}
          disabled={isChatMessageEmpty}
        >
          <SendIcon
            fontSize="large"
            color={isChatMessageEmpty ? "disabled" : "primary"}
          />
        </MessageActionButton>
      </MessageActionsContainer>
    </MessageActionsButtons>
  );
};
